// Emp1.jsx
import React, { useEffect, useState } from "react";
import ABTextEdu from "../../Common/ABTextEdu";
// import ABMonthYear from '../../Common/ABMonthYear';
import RadioButtonGroup from "../../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup";
import EMPDate from "../../EmploymentForm/empDate";
import QualificationDropdown from "../../DiyDigilockerNonIBridge/Dropdown";
import Checkbox from "../../../UI_Design/FormComponents/CheckboxAndLabel/Checkbox";
import EMPAutoCompleteSelect from "../../EmploymentForm/empAutoCompleteSelect";
import EMPText from "../../EmploymentForm/empText";
import EMPSimpleSelect from "../../EmploymentForm/empSimpleSelect";
import EMPCheckbox from "../../EmploymentForm/empCheckbox";
import {
  checkEmployeeCode,
  checkOtherCompanyName,
  dateFormat,
  validateAlphabetsAndSpace,
  validateContactNumber,
  validateEmail,
  validateMobileNumber711,
  validateNumeric,
  validatePAN,
  validateSSN,
  validateUAN,
} from "../../../Helper/common";
import {
  addEmployment,
  deleteAddEmploymentData,
  deletePrevEmploymentCountData,
  getEmployment,
  getPreviousEmploymentCount,
  getReasonOfLeavingOptions,
  removeEmployment,
  saveEmployment,
} from "../../../Actions/employmentActions";
import {
  alphabetsAndSpace,
  documentCheckboxDisabledClients,
  excludedFields,
  hrAndRMFields,
  instantFieldsMapping,
  instantModesFields,
  numbers711,
  numericOnly,
} from "../../EmploymentForm/empConstants";
import EMPSingleFileUpload from "../../EmploymentForm/empSingleFileUpload";
import EMPRadio from "../../EmploymentForm/empRadio";
import EMPMultipleUpload from "../../EmploymentForm/empMultipleUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmploymentGapReason,
  getEmploymentUpdatedDocuments,
  getEmploymentValidation,
  getLocationOptions,
} from "../../../Actions/employementActions_v2";
import { toast } from "react-toastify";
import EmploymentGaps from "../../EmploymentGaps";
import ConfirmationPopup from "../../EmploymentForm/confirmationPopup";
import TenureAlertPopUp from "../../EmploymentForm/TenureAlertPopUp";
import { getData } from "../../../Actions/landingAction";
import { getMRLDocument, removePreviousMRLDocument } from "../../../Actions/educationActions";

const EmploymentForm = ({
  clientId,
  checkData,
  fields,
  index,
  textHandler,
  allDisabled,
  otherInstituteObj,
  reasonOfLeavingOpt,
  states,
  currencies,
  countryCodeOptions,
  showProfilePreview,
  totalTabs,
  isEmpValidationRequired,
  isGapReason,
  catchIfAnyStatusIsNotCompleted,
  setCheckForAddEmployment,
  crossButtonEnabled,
  setShowAlertPopUp,
  setETypeShowGap,
  setEtypeErrorPopUp,
  setGapData,
  setFinalCaseCheckId,
  setFinalDataToBeSent,
  setHasGap,
  setGapReasonKey,
  etypeInfo,
  setEtypeInfo,
  saveEmploymentCallback,
  setAllFormInputErrors,
  setAllFormInputFields,
  fieldInput,
  errorData,
  isSelfEmployed,
  setIsSelfEmployed,
  isSSN,
  setIsSSN,
  showOtherVerificationSource,
  setShowOtherVerificationSource,
  otherVerificationSource,
  setOtherVerificationSource,
  otherVerificationError,
  setOtherVerificationError,
  otherDesignation,
  setOtherDesignation,
  showOtherDesignation,
  setShowOtherDesignation,
  otherDesignationError,
  setOtherDesignationError,
  otherReasonLeaving,
  setOtherReasonLeaving,
  showOtherReasonLeaving,
  setShowOtherReasonLeaving,
  otherReasonLeavingError,
  setOtherReasonLeavingError,
  otherLocation,
  setOtherLocation,
  showOtherLocation,
  setShowOtherLocation,
  otherLocationError,
  setOtherLocationError,
  tillDateChecked,
  setTillDateChecked,
  canConnectWithManager,
  setCanConnectWithManager,
  canConnectWithManager1,
  setCanConnectWithManager1,
  isDocProvidedChecked, 
  setIsDocProvidedChecked,
  uploadedDocuments, 
  setUploadedDocuments,
  requiredDocuments, 
  setRequiredDocuments,
  mobileCode, 
  setMobileCode,
  saveHandler,
  JLLdoj,
  employment_status,
  package_id,
  MRLDocs
}) => {
  const dispatch = useDispatch();

  const employmentAddStore = useSelector((state) => state.employmentAdd);
  const previousEmployment = useSelector((state) => state.previousEmployment);

  const [isContactRM, setIsContactRM] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const [maxDOJ, setMaxDOJ] = useState(null);
  const [minDOL, setMinDOL] = useState(null);

  const [instantModes, setInstantModes] = useState([]);
  const [instantModesError, setInstantModesError] = useState({});

  const [uploadedFilesCount, setUploadedFilesCount] = useState("");

  const [onContract, setonContract] = useState(false);

  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [previousEmpoymentCountPopUp, setPreviousEmploymentCountPopUp] =
    useState(false);

  const [locationList, setLocationList] = useState([]);

  const [verificationSourceId, setVerificationSourceId] = useState(null);
  const [verificationSourceName, setVerificationSourceName] = useState(null);

  useEffect(() => {
    let initialInput = {};
    let initialErrorData = {};
    let caseCheckId = checkData?.case_check_id;
    if(checkData?.verification_source_id) {
      setVerificationSourceId(checkData?.verification_source_id);
    } else {
      setVerificationSourceId(null);
    }

    if(checkData?.verification_source_name) {
      setVerificationSourceName(checkData?.verification_source_name)
    } else {
      setVerificationSourceName(null);
    }
    if (checkData?.fields) {
      for (let i in checkData?.fields) {
        initialInput[i] = checkData?.fields[i]?.field_value;
        initialErrorData[i] = false;

        if (i === "employed_in_company") {
          const isOnContract =
            checkData?.fields[i].field_value === "On contract (agency)"
              ? true
              : false;
          setonContract(isOnContract);
        }
      }

      checkInstantModes();
    }
    // if(checkData?.verification_source_id) {
    //   getCompanyLocation({name: checkData?.verification_source_name, value: checkData?.verification_source_id});
    // }
  }, [checkData]);

  useEffect(() => {
    setDateConditions();
  },[fieldInput])

  useEffect(() => {
    getUploadedFilesCount();
  }, [uploadedDocuments, requiredDocuments, MRLDocs]);

  useEffect(() => {
    if (
      employmentAddStore?.employmentAddData &&
      employmentAddStore?.employmentAddData?.message?.toUpperCase() ===
        "MAXIMUM EMPLOYMENTS ALREADY ADDED"
    ) {
      setShowAlertPopUp(true);
    } else {
      setShowAlertPopUp(false);
    }
  }, [employmentAddStore]);

  useEffect(() => {
    if (previousEmployment?.previousEmploymentCountData?.data?.valid == 0) {
      setPreviousEmploymentCountPopUp(true);
    } else if (
      previousEmployment?.previousEmploymentCountData?.data?.valid == 1
    ) {
      setShowRemovePopup(true);
      dispatch(deletePrevEmploymentCountData());
    } else {
      setPreviousEmploymentCountPopUp(false);
    }
  }, [previousEmployment]);

 const resetErrorForHRandRMfield = () => {
  const caseCheckId = checkData?.case_check_id
    let errorObj = {}
    for(var i in hrAndRMFields){
      if (!fieldInput[hrAndRMFields[i]] 
        || fieldInput[hrAndRMFields[i]].trim() == "" 
        || fieldInput[hrAndRMFields[i]] == null) {
        errorObj[hrAndRMFields[i]] = false;
      }
    }
   console.log("errorObj....", errorObj)
    setAllFormInputErrors((prevstate) => ({
      ...prevstate,
      [caseCheckId]: {
        ...prevstate[caseCheckId],
        ...errorObj,
      },
    }));
 }

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset, value } = checkboxValues;
    const caseCheckId = checkData?.case_check_id;
    const updatedErrorData = {}
    if (dataset.fieldname === "till_date") {
      let savedDate = dateFormat("DD-MM-YYYY", new Date());
      const updatedValue = tillDateChecked === true ? "" : "1";
      setTillDateChecked((prevState) => ({
        ...prevState,
        [caseCheckId]: !tillDateChecked,
      }));

      // setFieldInput((prevstate) => ({
      //   ...prevstate,
      //   [dataset.fieldname]: updatedValue,
      //   company_date_of_leaving: savedDate,
      // }));

      setAllFormInputFields((prevstate) => ({
        ...prevstate,
        [caseCheckId]: {
          ...prevstate[caseCheckId],
          [dataset.fieldname]: updatedValue,
          company_date_of_leaving: savedDate,
        },
      }));
      setAllFormInputErrors((prevstate) => ({
        ...prevstate,
        [caseCheckId]: {
          ...prevstate[caseCheckId],
          [dataset.fieldname]: false,
          company_date_of_leaving: false
        },
      }));
    }
    if (dataset.fieldname === "is_document_provided") {
      const updatedValue = isDocProvidedChecked === true ? "" : "1";
      // setIsDocProvidedChecked(!isDocProvidedChecked);
      setIsDocProvidedChecked(prevState => ({
        ...prevState,
        [caseCheckId]: !isDocProvidedChecked
      }))

      // setFieldInput((prevstate) => ({
      //   ...prevstate,
      //   [dataset.fieldname]: updatedValue,
      // }));

      setAllFormInputFields((prevstate) => ({
        ...prevstate,
        [caseCheckId]: {
          ...prevstate[caseCheckId],
          [dataset.fieldname]: updatedValue,
        },
      }));
       
        for (var i in requiredDocuments) {
          let docNotUploaded = false;
          const docID = requiredDocuments[i].id;
          const isMandatory = requiredDocuments[i].is_mandatory;
          for (var j in uploadedDocuments) {
            if (uploadedDocuments[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          if (isMandatory == 1) {
            updatedErrorData[`${requiredDocuments[i].document_name}`] =
              docNotUploaded;
          }
        }
        setAllFormInputErrors((prevstate) => ({
          ...prevstate,
          [caseCheckId]: {
            ...prevstate[caseCheckId],
            ...updatedErrorData,
          },
        }));
    }
  };

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;
    const caseCheckId = checkData?.case_check_id;
    checkForInputValidation(textValues);
    if (dataset.fieldname == "company_name") {
      if (value == "other") {
        setShowOtherVerificationSource((prevState) => ({
          ...prevState,
          [caseCheckId]: true,
        }));
      } else {
        setVerificationSourceId(null);
        setVerificationSourceName(null);
        setShowOtherVerificationSource((prevState) => ({
          ...prevState,
          [caseCheckId]: false,
        }));
      }
    }

    if (dataset.fieldname == "company_designation") {
      if (value == "other") {
        setShowOtherDesignation((prevState) => ({
          ...prevState,
          [caseCheckId]: true,
        }));
      } else {
        setShowOtherDesignation((prevState) => ({
          ...prevState,
          [caseCheckId]: false,
        }));
      }
    }

    if (dataset.fieldname == "reason_for_leaving") {
      if (value == "Other") {
        setShowOtherReasonLeaving((prevState) => ({
          ...prevState,
          [caseCheckId]: true,
        }));
      } else {
        setShowOtherReasonLeaving((prevState) => ({
          ...prevState,
          [caseCheckId]: false,
        }));
      }
    }

    // if (dataset.fieldname == "company_location") {
    //   if (value == "Other") {
    //     setShowOtherLocation((prevState) => ({
    //       ...prevState,
    //       [caseCheckId]: true,
    //     }));
    //   } else {
    //     setShowOtherLocation((prevState) => ({
    //       ...prevState,
    //       [caseCheckId]: false,
    //     }));
    //   }
    // }

    if (dataset.fieldname == "otherVerificationSource") {
      setOtherVerificationSource((prevState) => ({
        ...prevState,
        [caseCheckId]: value,
      }));
    } else if (dataset.fieldname == "otherDesignation") {
      setOtherDesignation((prevState) => ({
        ...prevState,
        [caseCheckId]: value,
      }));
    } else if (dataset.fieldname == "otherReasonLeaving") {
      setOtherReasonLeaving((prevState) => ({
        ...prevState,
        [caseCheckId]: value,
      }));
    // } else if (dataset.fieldname == "otherLocation") {
    //   setOtherLocation((prevState) => ({
    //     ...prevState,
    //     [caseCheckId]: value,
    //   }));
    } else {
      // setFieldInput((prevstate) => ({
      //   ...prevstate,
      //   [dataset.fieldname]: value,
      // }));
      setAllFormInputFields((prevstate) => ({
        ...prevstate,
        [caseCheckId]: {
          ...fieldInput,
          [dataset.fieldname]: value,
        },
      }));
    }
  };

  const checkForInputValidation = (textValues) => {
    const { dataset, value } = textValues;
    const caseCheckId = checkData?.case_check_id;

    if (dataset.fieldname.includes("email")) {
      checkEmailField(dataset, value);
    } else if (dataset.fieldname == "company_contact_no") {
      checkCompanyContactNumber(dataset, value);
    } else if (dataset.fieldname == "uan_number") {
      checkUANNumber(dataset, value);
    } else if (dataset.fieldname == "ssn_number") {
      checkSSNNumber(dataset, value);
    } else if (dataset.fieldname == "employment_pan_number" || dataset.fieldname == "pan_card_number") {
      checkPAN(dataset, value);
    } else if (numbers711.includes(dataset.fieldname)) {
      checkMobileNumber711(dataset, value);
    } else if (alphabetsAndSpace.includes(dataset.fieldname)) {
      checkAlphabetsAndSpace(dataset, value);
    } else if (numericOnly.includes(dataset.fieldname)) {
      checkNumericOnly(dataset, value);
    } else if (dataset.fieldname == "employee_code") {
      checkEmployeeCodeValidation(dataset, value);
    } else if (dataset.fieldname == "otherVerificationSource") {
      checkOtherCompanyValidation(dataset, value);
      console.log("reaching here...")
    } else {
      // setErrorData((prevstate) => ({
      //   ...prevstate,
      //   [dataset.fieldname]: false,
      // }));
      setAllFormInputErrors((prevstate) => ({
        ...prevstate,
        [caseCheckId]: {
          ...prevstate[caseCheckId],
          [dataset.fieldname]: false,
        },
      }));
    }
  };

  const checkEmailField = (dataset, value) => {
    let isValid = validateEmail(value);
    isValid = value ? isValid : true;
    changeErrorData(dataset, isValid);
  };

  const checkCompanyContactNumber = (dataset, value) => {
    let isValid = validateContactNumber(value);
    isValid = value ? isValid : true;
    changeErrorData(dataset, isValid);
  };

  const checkUANNumber = (dataset, value) => {
    let isValid = validateUAN(value);
    isValid = value ? isValid : true;
    changeErrorData(dataset, isValid);
  };
  const checkSSNNumber = (dataset, value) => {
    const isValid = validateSSN(value);
    changeErrorData(dataset, isValid);
  };

  const checkPAN = (dataset, value) => {
    const isValid = validatePAN(value);
    changeErrorData(dataset, isValid);
  };

  const checkMobileNumber711 = (dataset, value) => {
    let isValid = validateMobileNumber711(value);
    isValid = value ? isValid : true;
    changeErrorData(dataset, isValid);
  };

  const checkAlphabetsAndSpace = (dataset, value) => {
    let isValid = validateAlphabetsAndSpace(value);
    isValid = value ? isValid : true;
    changeErrorData(dataset, isValid);
  };

  const checkNumericOnly = (dataset, value) => {
    let isValid = validateNumeric(value);
    // only for cost to company field
    if (isValid && value?.length >= 5 && value > 0) {
      isValid = true;
    } else {
      isValid = false;
    }
    changeErrorData(dataset, isValid);
  };

  const checkEmployeeCodeValidation = (dataset, value) => {
    let isValid = checkEmployeeCode(value);
    isValid = value ? isValid : true;
    changeErrorData(dataset, isValid);
  };

  const checkOtherCompanyValidation = (dataset, value) => {
    let isValid = checkOtherCompanyName(value);
    const caseCheckId = checkData?.case_check_id;
    isValid = value ? isValid : true;
    console.log("other flag..", isValid)
    setOtherVerificationError((prevState) => ({
      ...prevState,
      [caseCheckId]: !isValid,
    }));
  };

  const changeErrorData = (dataset, isValid) => {
    const caseCheckId = checkData?.case_check_id;
    // setErrorData((prevstate) => ({
    //   ...prevstate,
    //   [dataset.fieldname]: !isValid,
    // }));
    setAllFormInputErrors((prevstate) => ({
      ...prevstate,
      [caseCheckId]: {
        ...prevstate[caseCheckId],
        [dataset.fieldname]: !isValid,
      },
    }));
  };

  const handleSaveDate = (checkDetailsIndex, fieldName, savedDate) => {
    const caseCheckId = checkData?.case_check_id;
    // setErrorData((prevstate) => ({
    //   ...prevstate,
    //   [fieldName]: false,
    // }));
    setAllFormInputErrors((prevstate) => ({
      ...prevstate,
      [caseCheckId]: {
        ...prevstate[caseCheckId],
        [fieldName]: false,
      },
    }));
    // setFieldInput((prevstate) => ({
    //   ...prevstate,
    //   [fieldName]: savedDate,
    // }));
    setAllFormInputFields((prevstate) => ({
      ...prevstate,
      [caseCheckId]: {
        ...prevstate[caseCheckId],
        [fieldName]: savedDate,
      },
    }));
  };

  const setDateConditions = () => {
    let dol = "";
    let doj = "";
    if (checkData?.check_id == "41" || checkData?.check_id == "261") {
      // const joiningDate = checkData?.fields["company_date_joining"]
      //   ? checkData?.fields["company_date_joining"].field_value
      //   : "";
      // const leavingDate = checkData?.fields["company_date_of_leaving"]
      //   ? checkData?.fields["company_date_of_leaving"].field_value
      //   : "";
      const joiningDate = fieldInput["company_date_joining"]
        ? fieldInput["company_date_joining"]
        : "";
      const leavingDate = fieldInput["company_date_of_leaving"]
        ? fieldInput["company_date_of_leaving"]
        : "";
      if (joiningDate !== "") {
        const [dd, mm, yyyy] = joiningDate.split("-");
        const futureDate = new Date(`${mm}/${dd}/${yyyy}`);
        futureDate.setDate(futureDate.getDate() + 1);
        dol = futureDate;
      } else {
        dol = null;
      }

      if (leavingDate !== "") {
        const [dd, mm, yyyy] = leavingDate.split("-");
        const pastDate = new Date(`${mm}/${dd}/${yyyy}`);
        pastDate.setDate(pastDate.getDate() - 1);
        doj = pastDate;
      } else {
        doj = null;
      }
    }
    setMaxDOJ(doj);
    setMinDOL(dol);
  };

  const checkInstantModes = () => {
    let instantModesArr = [];
    let instantModesErrorObj = {};
    const instantModesData = checkData?.instant_modes;
    for (let j = 0; j < instantModesData?.length; j++) {
      instantModesArr.push(instantModesFields[instantModesData[j]]);
      for (
        let k = 0;
        k < instantFieldsMapping[instantModesData[j]].length;
        k++
      ) {
        instantModesErrorObj[
          `${instantFieldsMapping[instantModesData[j]][k]}`
        ] = false;
      }
    }
    setInstantModes(instantModesArr);
    setInstantModesError(instantModesErrorObj);
  };

  const handleCountryCode = (e, mobileCodeFieldName) => {
    const caseCheckId = checkData.case_check_id
    const { dataset, value } = e.target;
    setMobileCode((prevstate) => ({
      ...prevstate,
      [caseCheckId] : {
        ...prevstate[caseCheckId],
        [mobileCodeFieldName]: value,
      }
    }));
  };

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    const caseCheckId = checkData?.case_check_id;
    // setErrorData((prevstate) => ({
    //   ...prevstate,
    //   [dataset.fieldname]: false,
    // }));
    setAllFormInputErrors((prevstate) => ({
      ...prevstate,
      [caseCheckId]: {
        ...prevstate[caseCheckId],
        [dataset.fieldname]: false,
      },
    }));
    // setFieldInput((prevstate) => ({
    //   ...prevstate,
    //   [dataset.fieldname]: value,
    // }));
    setAllFormInputFields((prevstate) => ({
      ...prevstate,
      [caseCheckId]: {
        ...prevstate[caseCheckId],
        [dataset.fieldname]: value,
      },
    }));
  };

  const getUploadedFilesCount = () => {
    let obj = {};
    if(MRLDocs?.required_documents?.length) {
      let MRLRequiredDocs = MRLDocs?.required_documents
      for (let j in MRLRequiredDocs) {
        let count = 0;
        for (let k in uploadedDocuments) {
          if (
            uploadedDocuments[k].document_id ==
            MRLRequiredDocs[j].id
          ) {
            count++;
          }
        }
        obj[`${MRLRequiredDocs[j].id}`] = count;
      }
    } else {
      for (let j in requiredDocuments) {
        let count = 0;
        for (let k in uploadedDocuments) {
          if (uploadedDocuments[k].document_id == requiredDocuments[j].id) {
            count++;
          }
        }
        obj[`${requiredDocuments[j].id}`] = count;
      }
    }

    setUploadedFilesCount(obj);
  };

  const getCountHandler = (record) => {
    return 1;
  };


  const getUpdatedDocuments = () => {
    dispatch(getEmploymentUpdatedDocuments(setUpdatedDocumentResponse));
  };

  const setUpdatedDocumentResponse = (data) => {
    const caseCheckId = checkData?.case_check_id
    let updatedEmployementRes = data?.data?.data;
    if (
      updatedEmployementRes?.checksDetails &&
      updatedEmployementRes.checksDetails[index - 1]
    ) {
      // setUploadedDocuments(
      //   updatedEmployementRes?.checksDetails[index - 1].uploaded_documents
      // );
      // setRequiredDocuments(
      //   updatedEmployementRes?.checksDetails[index - 1].required_documents
      // );
      setUploadedDocuments((prevState) => ({
        ...prevState,
        [caseCheckId] : updatedEmployementRes?.checksDetails[index - 1].uploaded_documents
      }))

      setRequiredDocuments((prevState) => ({
        ...prevState,
        [caseCheckId] : updatedEmployementRes?.checksDetails[index - 1].required_documents
      }))
    }
  };

  const handleEmploymentRemoveClick = (e) => {
    e.preventDefault();
    // setCheckIdToBeRemoved(caseCheckId);
    // setErrorIndexToBeRemoved(index);
    dispatch(getPreviousEmploymentCount());
    // console.log("previous....",previousEmployment?.previousEmploymentCountData)
  };

  const closeRemovePopup = () => {
    setShowRemovePopup(false);
  };

  const proceedRemove = async () => {
    await dispatch(removeEmployment(checkData?.case_check_id));
    await dispatch(getEmployment());
    dispatch(getData());
    setShowRemovePopup(false);
  };

  const closePreEmpCount = () => {
    setPreviousEmploymentCountPopUp(false);
    dispatch(deletePrevEmploymentCountData());
  };

  const proceedPreEmpCount = () => {
    setShowRemovePopup(true);
    dispatch(deletePrevEmploymentCountData());
  };

  const getCompanyLocation = (option = {}) => {
    const { value } = option;
    dispatch(getLocationOptions(value, getLocationList));
  }

  const getLocationList = (data) => {
    let compLocationList = data?.locations || [];
    compLocationList.push({
      "OFFICE_NAME": "Other"
    });

    setLocationList(compLocationList);
  }

    /** MRL DOC Code*/
    const checkDocApi = (payload, caseCheckId) => {
      dispatch(getMRLDocument(payload, caseCheckId))
    }

  return (
    <>
      {" "}
      {previousEmpoymentCountPopUp && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closePreEmpCount}
          title="Confirm"
          description={
            previousEmployment?.previousEmploymentCountData?.data?.msg
          }
          proceedHandler={proceedPreEmpCount}
          isAdd={false}
        />
      )}
      {showRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemovePopup}
          title="Remove Employment"
          description="Are you sure you want to remove this employment?"
          proceedHandler={proceedRemove}
          isAdd={false}
        />
      )}
      <div className="py-3">
        <h1 className="tabsContentHead">{`${checkData?.IB_CHECK_NAME}`}</h1>
        {/* <p className="tabsContentSubHead">
          Enter Your Most Recent Employment Details.
        </p> */}
        <div style={{ display: "flex", justifyContent: " space-between" }}>
          <div>
            <div className="row">
              {checkData.fields.is_ssn_country ? (
                <EMPRadio
                  name={`is_ssn_country_${checkData?.case_check_id}`}
                  id={`is_ssn_country_${checkData?.case_check_id}`}
                  fieldId={checkData.fields.is_ssn_country.ibridge_field_id}
                  label={checkData.fields.is_ssn_country.label}
                  isRequired={checkData.fields.is_ssn_country.is_mandatory}
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.is_ssn_country.ibridge_field_id}`}
                  options={{ Yes: "Yes", No: "No" }}
                  handleRadioChange={(radioValues) => {
                    const caseCheckId = checkData?.case_check_id;
                    handleRadioChange(radioValues);
                    if (radioValues?.value == "Yes") {
                      setIsSSN((prevState) => ({
                        ...prevState,
                        [caseCheckId]: true,
                      }));
                    } else {
                      setIsSSN((prevState) => ({
                        ...prevState,
                        [caseCheckId]: false,
                      }));
                    }
                  }}
                  checkDetailsIndex={index}
                  fieldName={"is_ssn_country"}
                  fieldValue={
                    fieldInput.is_ssn_country ||
                    checkData.fields.is_ssn_country.field_value
                  }
                  hasError={errorData["is_ssn_country"]}
                />
              ) : (
                <></>
              )}
            </div>
            <div className="row">
              {isSSN && checkData?.fields?.is_ssn_country && (
                <EMPText
                  name={`ssn_number_${checkData?.case_check_id}`}
                  id={`ssn_number_${checkData?.case_check_id}`}
                  fieldId={checkData.fields.ssn_number.ibridge_field_id}
                  label={checkData.fields.ssn_number.label}
                  isRequired={checkData.fields.ssn_number.is_mandatory}
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.ssn_number.ibridge_field_id}`}
                  handleTextChange={handleTextChange}
                  checkDetailsIndex={index}
                  fieldName={"ssn_number"}
                  fieldValue={
                    fieldInput.ssn_number ||
                    checkData.fields.ssn_number.field_value
                  }
                  hasError={errorData["ssn_number"]}
                  note={true}
                />
              )}
            </div>
            <div className="row">
              {checkData.fields.work_status ? (
                <EMPRadio
                  name={`work_status_${checkData?.case_check_id}`}
                  id={`work_status_${checkData?.case_check_id}`}
                  fieldId={checkData.fields.work_status.ibridge_field_id}
                  label={checkData.fields.work_status.label}
                  isRequired={checkData.fields.work_status.is_mandatory}
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.work_status.ibridge_field_id}`}
                  options={
                    checkData.fields.work_status.getFieldDisplay.optionArray
                      .options
                  }
                  handleRadioChange={(radioValues) => {
                    const caseCheckId = checkData.case_check_id;
                    handleRadioChange(radioValues);
                    if (radioValues?.value == "Self Employed") {
                      setIsSelfEmployed((prevState) => ({
                        ...prevState,
                        [caseCheckId]: true,
                      }));
                      resetErrorForHRandRMfield();
                    } else {
                      setIsSelfEmployed((prevState) => ({
                        ...prevState,
                        [caseCheckId]: false,
                      }));
                    }
                  }}
                  checkDetailsIndex={index}
                  fieldName={"work_status"}
                  fieldValue={fieldInput.work_status}
                  hasError={errorData["work_status"]}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
          <div>
            {index !== 1 &&
              checkData?.check_id != "58" &&
              crossButtonEnabled == 1 && (
                <button
                  class="btn btn-outline-secondary mt-2 mb-2"
                  onClick={(e) => {
                    e?.preventDefault();
                    setShowRemovePopup(true);
                  }}
                >
                  <i class="far fa-trash-alt mr-2"></i>
                  Remove
                </button>
              )}
          </div>
        </div>
        {isSelfEmployed === false && (
          <>
            <div className="row">
              {checkData.fields.employed_in_company ? (
                <EMPRadio
                  name={`employed_in_company_${checkData?.case_check_id}`}
                  id={`employed_in_company_${checkData?.case_check_id}`}
                  fieldId={
                    checkData.fields.employed_in_company.ibridge_field_id
                  }
                  label={checkData.fields.employed_in_company.label}
                  isRequired={checkData.fields.employed_in_company.is_mandatory}
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.employed_in_company.ibridge_field_id}`}
                  options={
                    checkData.fields.employed_in_company.getFieldDisplay
                      .optionArray.options
                  }
                  handleRadioChange={(radioValues) => {
                    handleRadioChange(radioValues);
                    if (radioValues?.value == "On contract (agency)") {
                      setonContract(true);
                    } else {
                      setonContract(false);
                    }
                  }}
                  checkDetailsIndex={index}
                  fieldName={"employed_in_company"}
                  fieldValue={fieldInput.employed_in_company}
                  hasError={errorData["employed_in_company"]}
                />
              ) : (
                <></>
              )}
            </div>
          </>
        )}
        {onContract === true && isSelfEmployed == false && (
          <div
            className="row"
            style={{
              marginLeft: "-15px",
              marginBottom: "15px",
              marginTop: "-5px",
            }}
          >
            <div className="col-sm-8 col-md-12 col-xl-8">
              <b>
                Please provide the employment details as per your payroll
                company.
              </b>
            </div>
          </div>
        )}
        <div className="initialDetails my-1">
          <h1 className="tabsContentHead pt-3">Company Details</h1>
          <div className="row">
            {!!checkData?.fields?.company_name && (
              <EMPAutoCompleteSelect
                name={`company_name_${checkData?.case_check_id}`}
                id={`company_name_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.company_name?.ibridge_field_id}
                label={checkData?.fields?.company_name?.label}
                isRequired={checkData?.fields?.company_name?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_name?.ibridge_field_id}`}
                handleTextChange={(textValues, selectedOption) => {
                  // console.log("selectedoption....", selectedOption.value);
                  // if (
                  //   selectedOption?.value &&
                  //   selectedOption?.value !== "Other"
                  // ) {
                  //   getCompanyLocation(selectedOption);
                  // } else if (selectedOption?.value === "Other") {
                  //   setLocationList([
                  //     {
                  //       OFFICE_NAME: "Other",
                  //     },
                  //   ]);
                  // }
                  const caseCheckId = checkData?.case_check_id;
                  handleTextChange(textValues);
                  // setErrorData((prevstate) => ({
                  //   ...prevstate,
                  //   company_name: false,
                  // }));
                  setAllFormInputErrors((prevstate) => ({
                    ...prevstate,
                    [caseCheckId]: {
                      ...prevstate[caseCheckId],
                      company_name: false,
                    },
                  }));
                  // remove previous 
                  // if(selectedOption?.value && selectedOption?.value != checkData?.verification_source_id){
                  //   removePreviousMRLDoc({
                  //     type: 2,
                  //     case_check_id: checkData?.case_check_id
                  //   })
                  // }
                  if(selectedOption?.value && !(checkData?.verification_source_id && selectedOption?.value == checkData?.verification_source_id)) {
                    checkDocApi({
                      verification_type: 2,
                      org_id: selectedOption?.value,
                      check_id: checkData?.check_id,
                      case_check_id : caseCheckId,
                      // delete: 1 // deleting previous docs in case org changes
                    }, caseCheckId)
                  }
                }}
                checkDetailsIndex={index}
                fieldName={"company_name"}
                fieldValue={fieldInput.company_name}
                hasError={errorData["company_name"]}
                verificationType={2}
                // handleInputTypeCallback={(e) => {
                //   e?.preventDefault();
                //   setLocationList([]);
                //   const caseCheckId = checkData?.case_check_id;
                //   setAllFormInputFields((prevstate) => ({
                //     ...prevstate,
                //     [caseCheckId]: {
                //       ...fieldInput,
                //       company_location: "",
                //       address_of_company: "", // resetting the values
                //       company_contact_no: "",
                //     },
                //   }));
                // }}
              />
            )}
            {showOtherVerificationSource && (
              <EMPText
                name={`otherVerificationSource_${checkData?.case_check_id}`}
                id={`otherVerificationSource_${checkData?.case_check_id}`}
                fieldId={null}
                label={"Other Company Name"}
                isRequired={1}
                errId={null}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"otherVerificationSource"}
                fieldValue={otherVerificationSource}
                hasError={otherVerificationError == true ? true : false}
              />
            )}
            {!!(package_id == 19599 || !!(
              ((!verificationSourceId && verificationSourceName) ||
                showOtherVerificationSource) &&
              checkData?.fields?.address_of_company
            )) && (
              <>
                <EMPText
                  name={`company_name_${checkData?.case_check_id}`}
                  id={`company_name_${checkData?.case_check_id}`}
                  fieldId={
                    checkData?.fields?.address_of_company?.ibridge_field_id
                  }
                  label={checkData?.fields?.address_of_company?.label}
                  isRequired={
                    checkData?.fields?.address_of_company?.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData?.fields?.address_of_company?.ibridge_field_id}`}
                  // divClass="col-sm-8 col-md-12 col-xl-8"
                  handleTextChange={handleTextChange}
                  checkDetailsIndex={index}
                  fieldName={"address_of_company"}
                  fieldValue={fieldInput.address_of_company}
                  hasError={errorData["address_of_company"]}
                />
              </>
            )}
            {!!(
              ((!verificationSourceId && verificationSourceName) ||
                showOtherVerificationSource) &&
              checkData?.fields?.company_contact_no
            ) && (
              <EMPText
                name={`company_contact_no_${checkData?.case_check_id}`}
                id={`company_contact_no_${checkData?.case_check_id}`}
                fieldId={
                  checkData?.fields?.company_contact_no?.ibridge_field_id
                }
                label={checkData?.fields?.company_contact_no?.label}
                isRequired={checkData?.fields?.company_contact_no?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_contact_no?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"company_contact_no"}
                fieldValue={fieldInput.company_contact_no}
                hasError={errorData["company_contact_no"]}
              />
            )}
            {checkData?.fields?.company_location && (
              <EMPText
                name={`company_location_${checkData?.case_check_id}`}
                id={`company_location_${checkData?.case_check_id}`}
                fieldId={checkData?.fields.company_location?.ibridge_field_id}
                label={checkData?.fields?.company_location?.label}
                isRequired={checkData?.fields?.company_location?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_location?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"company_location"}
                fieldValue={fieldInput.company_location}
                hasError={errorData["company_location"]}
              />
            )}
            {/* {checkData?.fields?.company_location && (
              <EMPSimpleSelect
                name={`company_location${checkData?.case_check_id}`}
                id={`company_location${checkData?.case_check_id}`}
                label={checkData?.fields?.company_location?.label}
                autoComplete="off"
                options={locationList || []}
                isRequired={checkData?.fields?.company_location?.is_mandatory}
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"company_location"}
                fieldValue={fieldInput.company_location}
                hasError={errorData["company_location"]}
                isDisabled={!fieldInput.company_name}
              />
            )} */}
            {/* other location field */}
            {/* {showOtherLocation && (
              <EMPText
                name={`otherLocation_${checkData?.case_check_id}`}
                id={`otherLocation_${checkData?.case_check_id}`}
                fieldId={null}
                label={`Other Location`}
                isRequired={1}
                errId={null}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"otherLocation"}
                fieldValue={otherLocation}
                hasError={otherLocationError}
              />
            )} */}
            {checkData?.fields?.company_employment_type && (
              <EMPSimpleSelect
                name={`company_employment_type_${checkData?.case_check_id}`}
                id={`company_employment_type_${checkData?.case_check_id}`}
                label={checkData?.fields?.company_employment_type?.label}
                autoComplete="off"
                options={
                  checkData?.fields?.company_employment_type?.getFieldDisplay
                    ?.optionArray?.options
                }
                isRequired={
                  checkData?.fields?.company_employment_type?.is_mandatory
                }
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"company_employment_type"}
                fieldValue={fieldInput.company_employment_type}
                hasError={errorData["company_employment_type"]}
              />
            )}
            {checkData?.fields?.company_nature_of_employment && (
              <EMPSimpleSelect
                name={`company_nature_of_employment_${checkData?.case_check_id}`}
                id={`company_nature_of_employment_${checkData?.case_check_id}`}
                label={checkData?.fields?.company_nature_of_employment?.label}
                autoComplete="off"
                options={
                  checkData?.fields?.company_nature_of_employment
                    ?.getFieldDisplay?.optionArray?.options
                }
                isRequired={
                  checkData?.fields?.company_nature_of_employment?.is_mandatory
                }
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"company_nature_of_employment"}
                fieldValue={fieldInput.company_nature_of_employment}
                hasError={errorData["company_nature_of_employment"]}
              />
            )}
            {checkData?.fields?.corporate_email_id && (
              <EMPText
                name={`corporate_email_id_${checkData?.case_check_id}`}
                id={`corporate_email_id_${checkData?.case_check_id}`}
                fieldId={
                  checkData?.fields?.corporate_email_id?.ibridge_field_id
                }
                label={checkData?.fields?.corporate_email_id?.label}
                isRequired={
                  instantModes?.length > 0 &&
                  instantModes?.includes("Corporate Email ID Validation")
                    ? 1
                    : checkData?.fields?.corporate_email_id?.is_mandatory
                }
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.corporate_email_id?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"corporate_email_id"}
                fieldValue={fieldInput.corporate_email_id}
                hasError={errorData["corporate_email_id"]}
              />
            )}
            {checkData?.fields?.company_date_joining && (
              <EMPDate
                paramStartDate={null}
                placeholder={checkData?.fields?.company_date_joining?.label}
                name={`company_date_joining_${checkData?.case_check_id}`}
                id={`company_date_joining_${checkData?.case_check_id}`}
                fieldId={
                  checkData?.fields?.company_date_joining?.ibridge_field_id
                }
                label={checkData?.fields?.company_date_joining?.label}
                isRequired={
                  checkData?.fields?.company_date_joining?.is_mandatory
                }
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_date_joining?.ibridge_field_id}`}
                intialStatus={0}
                saveDate={handleSaveDate}
                checkID={checkData?.check_id}
                maxDOJDate={maxDOJ}
                checkDetailsIndex={index}
                fieldName={"company_date_joining"}
                fieldValue={fieldInput.company_date_joining}
                hasError={errorData["company_date_joining"]}
                JLLdoj={employment_status == 3 ? JLLdoj : ""}
                dob={localStorage.getItem('dob') || ""}
              />
            )}
            {checkData?.fields?.company_date_of_leaving &&
              !(tillDateChecked && tillDateChecked === true) && (
                <EMPDate
                  paramStartDate={null}
                  placeholder={
                    checkData?.fields?.company_date_of_leaving?.label
                  }
                  name={`company_date_of_leaving_${checkData?.case_check_id}`}
                  id={`company_date_of_leaving_${checkData?.case_check_id}`}
                  fieldId={
                    checkData?.fields?.company_date_of_leaving?.ibridge_field_id
                  }
                  label={checkData?.fields?.company_date_of_leaving?.label}
                  isRequired={
                    checkData?.fields?.company_date_of_leaving?.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_date_of_leaving?.ibridge_field_id}`}
                  intialStatus={0}
                  isDisabled={
                    tillDateChecked && tillDateChecked === true ? true : false
                  }
                  saveDate={handleSaveDate}
                  checkDetailsIndex={index}
                  checkID={checkData?.check_id}
                  minDateDOL={minDOL}
                  fieldName={"company_date_of_leaving"}
                  fieldValue={fieldInput.company_date_of_leaving}
                  hasError={errorData["company_date_of_leaving"]}
                  JLLdoj={employment_status == 3 ? JLLdoj : ""}
                  dob={localStorage.getItem('dob') || ""}
                />
              )}
            {checkData?.fields?.till_date && (
              <EMPCheckbox
                name={`till_date_${checkData?.case_check_id}`}
                id={`till_date_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.till_date?.ibridge_field_id}
                label={checkData?.fields?.till_date?.label}
                isRequired={checkData?.fields?.till_date?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData.fields.till_date.ibridge_field_id}`}
                handleCheckboxChange={handleCheckboxChange}
                checkDetailsIndex={index}
                fieldName={"till_date"}
                fieldValue={fieldInput.till_date}
                hasError={errorData["till_date"]}
              />
            )}
          </div>
        </div>

        <div className={`kycDetails ${!!(checkData?.fields?.company_designation 
              || checkData?.fields?.company_department 
              || checkData?.fields?.roles_responsibilities) ? "border-top": ""} my-1`}>
          {
            !!(checkData?.fields?.company_designation 
              || checkData?.fields?.company_department 
              || checkData?.fields?.roles_responsibilities) && 
              <h1 className="tabsContentHead pt-3">Job/Role Details</h1>
          }
          <div className="row">
            {checkData?.fields?.company_designation && (
              <EMPAutoCompleteSelect
                name={`company_designation_${checkData?.case_check_id}`}
                id={`company_designation_${checkData?.case_check_id}`}
                fieldId={
                  checkData?.fields?.company_designation?.ibridge_field_id
                }
                label={checkData?.fields?.company_designation?.label}
                isRequired={
                  checkData?.fields?.company_designation?.is_mandatory
                }
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_designation?.ibridge_field_id}`}
                handleTextChange={(textValues, selectedOption) => {
                  const caseCheckId = checkData?.case_check_id;
                  handleTextChange(textValues);
                  // setErrorData((prevstate) => ({
                  //   ...prevstate,
                  //   company_designation: false,
                  // }));
                  setAllFormInputErrors((prevstate) => ({
                    ...prevstate,
                    [caseCheckId]: {
                      ...prevstate[caseCheckId],
                      company_designation: false,
                    },
                  }));
                }}
                checkDetailsIndex={index}
                fieldName={"company_designation"}
                fieldValue={fieldInput.company_designation}
                hasError={errorData["company_designation"]}
                verificationType={2}
              />
            )}
            {/* Other designation field */}
            {showOtherDesignation && (
              <EMPText
                name={`otherDesignation_${checkData?.case_check_id}`}
                id={`otherDesignation__${checkData?.case_check_id}`}
                fieldId={null}
                label={`Other Designation`}
                isRequired={1}
                errId={null}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"otherDesignation"}
                fieldValue={otherDesignation}
                hasError={otherDesignationError == true ? true : false}
              />
            )}
            {checkData?.fields?.employee_code && (
              <EMPText
                name={`employee_code_${checkData?.case_check_id}`}
                id={`employee_code_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.employee_code?.ibridge_field_id}
                label={checkData?.fields?.employee_code?.label}
                isRequired={ MRLDocs?.required_fields?.findIndex(fieldId => fieldId == checkData?.fields?.employee_code?.ibridge_field_id) > -1 ? 1 :
                  isSelfEmployed == true
                    ? 0
                    : checkData.fields.employee_code.is_mandatory
                }
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.employee_code?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"employee_code"}
                fieldValue={fieldInput.employee_code}
                hasError={errorData["employee_code"]}
                dataTip={MRLDocs?.required_fields?.findIndex(fieldId => fieldId == checkData?.fields?.employee_code?.ibridge_field_id) > -1 && fieldInput.company_name
                  ? `${fieldInput.company_name} needs this info for providing verification` : ""}
              />
            )}
            {checkData.fields.salary_currency && (
              <EMPSimpleSelect
                name={`salary_currency_${checkData?.case_check_id}`}
                id={`salary_currency_${checkData?.case_check_id}`}
                label={checkData.fields.salary_currency.label}
                autoComplete="off"
                options={currencies}
                isRequired={checkData.fields.salary_currency.is_mandatory}
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"salary_currency"}
                fieldValue={fieldInput.salary_currency}
                hasError={errorData["salary_currency"]}
              />
            )}
            {checkData.fields.cost_to_company && (
              <EMPText
                name={`cost_to_company_${checkData?.case_check_id}`}
                id={`cost_to_company_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.cost_to_company?.ibridge_field_id}
                label={checkData?.fields?.cost_to_company?.label}
                isRequired={checkData?.fields?.cost_to_company?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.cost_to_company?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"cost_to_company"}
                fieldValue={fieldInput.cost_to_company}
                hasError={errorData["cost_to_company"]}
              />
            )}
            {checkData?.fields?.annual_salary && (
              <EMPSimpleSelect
                name={`annual_salary_${checkData?.case_check_id}`}
                id={`annual_salary_${checkData?.case_check_id}`}
                label={checkData?.fields?.annual_salary?.label}
                autoComplete="off"
                options={
                  checkData?.fields?.annual_salary?.getFieldDisplay?.optionArray
                    ?.options
                }
                isRequired={checkData?.fields.annual_salary?.is_mandatory}
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"annual_salary"}
                fieldValue={fieldInput.annual_salary}
                hasError={errorData["annual_salary"]}
              />
            )}
            {checkData?.fields?.reason_for_leaving && (
              <EMPSimpleSelect
                name={`reason_for_leaving_${checkData?.case_check_id}`}
                id={`reason_for_leaving_${checkData?.case_check_id}`}
                label={checkData?.fields?.reason_for_leaving?.label}
                autoComplete="off"
                options={reasonOfLeavingOpt || {}}
                isRequired={checkData?.fields?.reason_for_leaving?.is_mandatory}
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"reason_for_leaving"}
                fieldValue={fieldInput.reason_for_leaving}
                hasError={errorData["reason_for_leaving"]}
              />
            )}
            {/* other reason for leaving field */}
            {showOtherReasonLeaving && (
              <EMPText
                name={`otherReasonLeaving_${checkData?.case_check_id}`}
                id={`otherReasonLeaving_${checkData?.case_check_id}`}
                fieldId={null}
                label={`Other Reason`}
                isRequired={1}
                errId={null}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"otherReasonLeaving"}
                fieldValue={otherReasonLeaving}
                hasError={otherReasonLeavingError}
              />
            )}
            {checkData?.fields?.uan_number && (
              <EMPText
                name={`uan_number_${checkData?.case_check_id}`}
                id={`uan_number_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.uan_number?.ibridge_field_id}
                label={checkData?.fields?.uan_number?.label}
                isRequired={
                  instantModes?.length > 0 && instantModes?.includes("UAN")
                    ? 1
                    : checkData?.fields?.uan_number?.is_mandatory
                }
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.uan_number?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"uan_number"}
                fieldValue={fieldInput.uan_number}
                hasError={errorData["uan_number"]}
                isDisabled={checkData?.fields?.uan_number?.readonly || false}
              />
            )}
            {checkData?.fields?.company_department && (
              <EMPText
                name={`company_department_${checkData?.case_check_id}`}
                id={`company_department_${checkData?.case_check_id}`}
                fieldId={
                  checkData?.fields?.company_department?.ibridge_field_id
                }
                label={checkData?.fields?.company_department?.label}
                isRequired={checkData?.fields?.company_department?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.company_department?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"company_department"}
                fieldValue={fieldInput.company_department}
                hasError={errorData["company_department"]}
              />
            )}
            {checkData?.fields?.roles_responsibilities && (
              <EMPText
                name={`roles_responsibilities_${checkData?.case_check_id}`}
                id={`roles_responsibilities_${checkData?.case_check_id}`}
                fieldId={
                  checkData?.fields?.roles_responsibilities?.ibridge_field_id
                }
                label={checkData?.fields?.roles_responsibilities?.label}
                isRequired={
                  checkData?.fields?.roles_responsibilities?.is_mandatory
                }
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.roles_responsibilities?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"roles_responsibilities"}
                fieldValue={fieldInput.roles_responsibilities}
                hasError={errorData["roles_responsibilities"]}
              />
            )}
            {checkData?.fields?.extra_remarks && (
              <EMPText
                name={`extra_remarks_${checkData?.case_check_id}`}
                id={`extra_remarks_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.extra_remarks?.ibridge_field_id}
                label={checkData?.fields?.extra_remarks?.label}
                isRequired={checkData?.fields?.extra_remarks?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.extra_remarks?.ibridge_field_id}`}
                // divClass="col-sm-8 col-md-12 col-xl-8"
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"extra_remarks"}
                fieldValue={fieldInput.extra_remarks}
                hasError={errorData["extra_remarks"]}
              />
            )}
            {checkData.fields.location && (
              <EMPSimpleSelect
                name={`location_${checkData?.case_check_id}`}
                id={`location_${checkData?.case_check_id}`}
                label={checkData.fields.location.label}
                autoComplete="off"
                options={states}
                isRequired={checkData.fields.location.is_mandatory}
                caseCheckId={checkData?.case_check_id}
                handleSelectChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"location"}
                fieldValue={fieldInput.location}
                hasError={errorData["location"]}
              />
            )}
            {
              MRLDocs?.required_fields?.map(fieldId => {
                return (
                  Object.entries(checkData?.fields || {})?.map(checkFields => {

                    if (checkFields[1].id == fieldId 
                      && checkFields[0] != "employee_code") {
                      return (
                        <EMPText
                          name={`${checkFields[0]}_${checkData?.case_check_id}`}
                          id={`${checkFields[0]}_${checkData?.case_check_id}`}
                          fieldId={checkFields[1]?.ibridge_field_id}
                          label={checkFields[1]?.label}
                          isRequired={1}
                          errId={`err_${checkData?.case_check_id}_${checkFields[1]?.ibridge_field_id}`}
                          // divClass="col-sm-8 col-md-12 col-xl-8"
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={index}
                          fieldName={checkFields[0]}
                          fieldValue={fieldInput[checkFields[0]]}
                          hasError={errorData[checkFields[0]]}
                          dataTip={fieldInput?.company_name ? `${fieldInput.company_name} needs this info for providing verification` : ""}
                        />
                      )
                    }
                  })
                )

              })
            }
            {checkData?.fields?.reliveing_letter_date &&
              !!(tillDateChecked && tillDateChecked === true) && (
                <p className="col-12">
                  {checkData?.fields?.reliveing_letter_date?.label}
                </p>
              )}
            {checkData?.fields?.reliveing_letter_date &&
              !!(tillDateChecked && tillDateChecked === true) && (
                <EMPDate
                  paramStartDate={null}
                  placeholder={"Date"}
                  name={`reliveing_letter_date_${checkData?.case_check_id}`}
                  id={`reliveing_letter_date_${checkData?.case_check_id}`}
                  fieldId={
                    checkData?.fields?.reliveing_letter_date?.ibridge_field_id
                  }
                  label={checkData?.fields?.reliveing_letter_date?.label}
                  isRequired={
                    checkData?.fields?.reliveing_letter_date?.is_mandatory
                  }
                  checkID={checkData?.check_id}
                  errId={`err_${checkData?.case_check_id}_${checkData?.fields?.reliveing_letter_date?.ibridge_field_id}`}
                  intialStatus={0}
                  saveDate={handleSaveDate}
                  checkDetailsIndex={index}
                  fieldName={"reliveing_letter_date"}
                  fieldValue={fieldInput.reliveing_letter_date}
                  hasError={errorData["reliveing_letter_date"]}
                />
              )}
          </div>
        </div>

        <div className="kycDetails my-1">
          {/* <h1 className="tabsContentHead pt-3">Other Details</h1> */}
          <div className="row">
            {checkData?.fields?.grade && (
              <EMPText
                name={`grade_${checkData?.case_check_id}`}
                id={`grade_${checkData?.case_check_id}`}
                fieldId={checkData?.fields?.grade?.ibridge_field_id}
                label={checkData?.fields?.grade?.label}
                isRequired={checkData?.fields?.grade?.is_mandatory}
                errId={`err_${checkData?.case_check_id}_${checkData?.fields?.grade?.ibridge_field_id}`}
                handleTextChange={handleTextChange}
                checkDetailsIndex={index}
                fieldName={"grade"}
                fieldValue={fieldInput.grade}
                hasError={errorData["grade"]}
              />
            )}
            {/* <p className="col-12">When can you submit reliving letter</p> */}
            {/* {checkData?.fields?.reliveing_letter_date &&
              !!(tillDateChecked && tillDateChecked === true) && (
                <p className="col-12">
                  {checkData?.fields?.reliveing_letter_date?.label}
                </p>
              )}
            {checkData?.fields?.reliveing_letter_date &&
              !!(tillDateChecked && tillDateChecked === true) && (
                <EMPDate
                  paramStartDate={null}
                  placeholder={"Date"}
                  name={`reliveing_letter_date_${checkData?.case_check_id}`}
                  id={`reliveing_letter_date_${checkData?.case_check_id}`}
                  fieldId={
                    checkData?.fields?.reliveing_letter_date?.ibridge_field_id
                  }
                  label={checkData?.fields?.reliveing_letter_date?.label}
                  isRequired={
                    checkData?.fields?.reliveing_letter_date?.is_mandatory
                  }
                  checkID={checkData?.check_id}
                  errId={`err_${checkData?.case_check_id}_${checkData?.fields?.reliveing_letter_date?.ibridge_field_id}`}
                  intialStatus={0}
                  saveDate={handleSaveDate}
                  checkDetailsIndex={index}
                  fieldName={"reliveing_letter_date"}
                  fieldValue={fieldInput.reliveing_letter_date}
                  hasError={errorData["reliveing_letter_date"]}
                />
              )} */}
          </div>
        </div>
        {instantModes?.length > 0 && instantModes?.includes("Form 16") && (
          <div className="kycDetails border-top my-1">
            <h1 className="tabsContentHead pt-3">Form 16 Details</h1>
            <div className="row">
              {checkData.fields.employment_pan_number && (
                <EMPText
                  name={`employment_pan_number_${checkData?.case_check_id}`}
                  id={`employment_pan_number_${checkData?.case_check_id}`}
                  fieldId={
                    checkData.fields.employment_pan_number.ibridge_field_id
                  }
                  label={checkData.fields.employment_pan_number.label}
                  isRequired={
                    checkData.fields.employment_pan_number.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.employment_pan_number.ibridge_field_id}`}
                  handleTextChange={handleTextChange}
                  checkDetailsIndex={index}
                  fieldName={"employment_pan_number"}
                  fieldValue={fieldInput.employment_pan_number}
                  hasError={errorData["employment_pan_number"]}
                />
              )}
              {checkData.fields.employment_tan_number && (
                <EMPText
                  name={`employment_tan_number_${checkData?.case_check_id}`}
                  id={`employment_tan_number_${checkData?.case_check_id}`}
                  fieldId={
                    checkData.fields.employment_tan_number.ibridge_field_id
                  }
                  label={checkData.fields.employment_tan_number.label}
                  isRequired={
                    checkData.fields.employment_tan_number.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.employment_tan_number.ibridge_field_id}`}
                  handleTextChange={handleTextChange}
                  checkDetailsIndex={index}
                  fieldName={"employment_tan_number"}
                  fieldValue={fieldInput.employment_tan_number}
                />
              )}
              {checkData.fields.employment_assessment_year && (
                <EMPText
                  name={`employment_assessment_year_${checkData?.case_check_id}`}
                  id={`employment_assessment_year_${checkData?.case_check_id}`}
                  fieldId={
                    checkData.fields.employment_assessment_year.ibridge_field_id
                  }
                  label={checkData.fields.employment_assessment_year.label}
                  isRequired={
                    checkData.fields.employment_assessment_year.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.employment_assessment_year.ibridge_field_id}`}
                  handleTextChange={handleTextChange}
                  checkDetailsIndex={index}
                  fieldName={"employment_assessment_year"}
                  fieldValue={fieldInput.employment_assessment_year}
                  hasError={errorData["employment_assessment_year"]}
                />
              )}
              {checkData.fields.employment_certificate_no && (
                <EMPText
                  name={`employment_certificate_no_${checkData?.case_check_id}`}
                  id={`employment_certificate_no_${checkData?.case_check_id}`}
                  fieldId={
                    checkData.fields.employment_certificate_no.ibridge_field_id
                  }
                  label={checkData.fields.employment_certificate_no.label}
                  isRequired={
                    checkData.fields.employment_certificate_no.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.employment_certificate_no.ibridge_field_id}`}
                  handleTextChange={handleTextChange}
                  checkDetailsIndex={index}
                  fieldName={"employment_certificate_no"}
                  fieldValue={fieldInput.employment_certificate_no}
                />
              )}
            </div>
            <div className="row">
              <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                  <EMPSingleFileUpload
                    inputType={8}
                    inputName={"form_16"}
                    inputValue={
                      checkData.fields.employment_pan_number.field_value
                    }
                    isInputMandatory={1}
                    inputLabel={"Form 16"}
                    index={index - 1}
                    // handleFileUpload={handleFileUpload}
                    record={{
                      caseCheckId: checkData?.case_check_id,
                      docId: checkData.instant_mode_documents[3].id,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {instantModes?.length > 0 &&
          instantModes?.includes("Employee Validation Via OTP") && (
            <div className="kycDetails border-top my-1">
              <div className="row">
                {checkData.fields.employment_cand_mobile_no && (
                  <EMPText
                    name={`employment_cand_mobile_no_${checkData?.case_check_id}`}
                    id={`employment_cand_mobile_no_${checkData?.case_check_id}`}
                    fieldId={
                      checkData.fields.employment_cand_mobile_no
                        .ibridge_field_id
                    }
                    label={checkData.fields.employment_cand_mobile_no.label}
                    isRequired={
                      checkData.fields.employment_cand_mobile_no.is_mandatory
                    }
                    errId={`err_${checkData?.case_check_id}_${checkData.fields.employment_cand_mobile_no.ibridge_field_id}`}
                    handleTextChange={handleTextChange}
                    checkDetailsIndex={index}
                    fieldName={"employment_cand_mobile_no"}
                    fieldValue={fieldInput.employment_cand_mobile_no}
                    hasError={errorData["employment_cand_mobile_no"]}
                  />
                )}
              </div>
            </div>
          )}
        {instantModes?.length > 0 &&
          instantModes?.includes("Bank Statement Analyser") && (
            <div className="kycDetails border-top my-1">
              <div className="row">
                {checkData.fields.employment_monthly_salary && (
                  <EMPText
                    name={`employment_monthly_salary_${checkData?.case_check_id}`}
                    id={`employment_monthly_salary_${checkData?.case_check_id}`}
                    fieldId={
                      checkData.fields.employment_monthly_salary
                        .ibridge_field_id
                    }
                    label={checkData.fields.employment_monthly_salary.label}
                    isRequired={
                      checkData.fields.employment_monthly_salary.is_mandatory
                    }
                    errId={`err_${checkData?.case_check_id}_${checkData.fields.employment_monthly_salary.ibridge_field_id}`}
                    handleTextChange={handleTextChange}
                    checkDetailsIndex={index}
                    fieldName={"employment_monthly_salary"}
                    fieldValue={fieldInput.employment_monthly_salary}
                    hasError={errorData["employment_monthly_salary"]}
                  />
                )}
              </div>
              <div className="row">
                <div className="col-sm-4 col-md-12 col-xl-4">
                  <div className="form-group">
                    <EMPSingleFileUpload
                      inputType={8}
                      inputName={"bank_statement"}
                      inputValue={
                        checkData.fields.employment_pan_number.field_value
                      }
                      isInputMandatory={1}
                      inputLabel={"Bank Statement"}
                      index={index - 1}
                      // handleFileUpload={handleFileUpload}
                      record={{
                        caseCheckId: checkData?.case_check_id,
                        docId: checkData.instant_mode_documents[4].id,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        {checkData?.case_check_id != "281" &&
          checkData?.case_check_id != "282" && 
          (checkData?.fields?.manager_first_name || checkData?.fields?.manager_first_name1) &&
          <div className="international-worker border-top my-1">
            <h1 className="tabsContentHead pt-3">Reporting Manager Details</h1>
          </div>
        }
        {checkData?.case_check_id != "281" &&
          checkData?.case_check_id != "282" && 
          (checkData?.fields?.manager_first_name) && (          
            <>
              <div className="international-worker border-top my-1">
                <h1 className="tabsContentHead pt-3">
                  Reporting Manager 1
                </h1>
                {clientId == "131479" && (
                  <div className="row">
                    <p>
                      (Please provide only the Active contact details as this
                      information will be used for verification)
                    </p>
                  </div>
                )}
                {clientId == "312004" && checkData?.case_check_id == "58" && (
                  <div className="row">
                    <p>
                      Your Current Employer will be contacted post your joining
                      at Sophos
                    </p>
                  </div>
                )}
                <div className="row">
                  {checkData?.fields?.manager_first_name && (
                    <EMPText
                      name={`manager_first_name_${checkData?.case_check_id}`}
                      id={`manager_first_name_${checkData?.case_check_id}`}
                      fieldId={
                        checkData?.fields?.manager_first_name?.ibridge_field_id
                      }
                      label={checkData?.fields?.manager_first_name?.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData?.fields?.manager_first_name?.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_first_name?.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={index}
                      fieldName={"manager_first_name"}
                      fieldValue={fieldInput.manager_first_name}
                      hasError={errorData["manager_first_name"]}
                    />
                  )}

                  {checkData?.fields?.manager_middle_name && (
                    <EMPText
                      name={`manager_middle_name_${checkData?.case_check_id}`}
                      id={`manager_middle_name_${checkData?.case_check_id}`}
                      fieldId={
                        checkData?.fields?.manager_middle_name?.ibridge_field_id
                      }
                      label={checkData?.fields?.manager_middle_name?.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData?.fields?.manager_middle_name?.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_middle_name?.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={index}
                      fieldName={"manager_middle_name"}
                      fieldValue={fieldInput?.manager_middle_name}
                      hasError={errorData["manager_middle_name"]}
                    />
                  )}
                  {checkData?.fields?.manager_last_name && (
                    <EMPText
                      name={`manager_last_name_${checkData?.case_check_id}`}
                      id={`manager_last_name_${checkData?.case_check_id}`}
                      fieldId={
                        checkData?.fields?.manager_last_name?.ibridge_field_id
                      }
                      label={checkData?.fields?.manager_last_name?.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData?.fields?.manager_last_name?.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_last_name?.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={index}
                      fieldName={"manager_last_name"}
                      fieldValue={fieldInput.manager_last_name}
                      hasError={errorData["manager_last_name"]}
                    />
                  )}
                  {checkData.fields.manager_email_id && (
                    <EMPText
                      name={`manager_email_id_${checkData?.case_check_id}`}
                      id={`manager_email_id_${checkData?.case_check_id}`}
                      fieldId={
                        checkData.fields.manager_email_id.ibridge_field_id
                      }
                      label={checkData.fields.manager_email_id.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData.fields.manager_email_id.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData.fields.manager_email_id.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={index}
                      fieldName={"manager_email_id"}
                      fieldValue={fieldInput.manager_email_id}
                      hasError={errorData["manager_email_id"]}
                    />
                  )}

                  {checkData.fields.manager_mobile_no && (
                    <EMPText
                      name={`manager_mobile_no_${checkData?.case_check_id}`}
                      id={`manager_mobile_no_${checkData?.case_check_id}`}
                      fieldId={
                        checkData.fields.manager_mobile_no.ibridge_field_id
                      }
                      label={checkData.fields.manager_mobile_no.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData.fields.manager_mobile_no.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData.fields.manager_mobile_no.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={index}
                      fieldName={"manager_mobile_no"}
                      fieldValue={fieldInput.manager_mobile_no}
                      countryCodeValue={
                        mobileCode?.mobile_code_manager ||
                        checkData.fields.manager_mobile_no.country_code_value
                      }
                      hasError={errorData["manager_mobile_no"]}
                      countryCodeOptions={countryCodeOptions}
                      handleCountryCode={(e) =>
                        handleCountryCode(e, "mobile_code_manager")
                      }
                    />
                  )}
                  {checkData?.fields?.manager_designation && (
                    <EMPText
                      name={`manager_designation_${checkData?.case_check_id}`}
                      id={`manager_designation_${checkData?.case_check_id}`}
                      fieldId={
                        checkData?.fields?.manager_designation?.ibridge_field_id
                      }
                      label={checkData?.fields?.manager_designation?.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData?.fields?.manager_designation?.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_designation?.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={index}
                      fieldName={"manager_designation"}
                      fieldValue={fieldInput.manager_designation}
                      hasError={errorData["manager_designation"]}
                    />
                  )}
                  {checkData?.fields?.connect_with_manager && (
                    <EMPRadio
                      name={`connect_with_manager_${checkData?.case_check_id}`}
                      id={`connect_with_manager_${checkData?.case_check_id}`}
                      fieldId={
                        checkData?.fields?.connect_with_manager
                          ?.ibridge_field_id
                      }
                      label={checkData?.fields?.connect_with_manager?.label}
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData?.fields?.connect_with_manager
                              ?.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData?.fields?.connect_with_manager?.ibridge_field_id}`}
                      options={
                        checkData?.fields?.connect_with_manager?.getFieldDisplay
                          ?.optionArray?.options
                      }
                      handleRadioChange={(radioValues) => {
                        const caseCheckId = checkData?.case_check_id;
                        handleRadioChange(radioValues);
                        if (radioValues?.value == "Yes") {
                          setCanConnectWithManager((prevState) => ({
                            ...prevState,
                            [caseCheckId]: true,
                          }));
                        } else {
                          setCanConnectWithManager((prevState) => ({
                            ...prevState,
                            [caseCheckId]: false,
                          }));
                        }
                      }}
                      checkDetailsIndex={index}
                      fieldName={"connect_with_manager"}
                      fieldValue={fieldInput.connect_with_manager}
                      hasError={errorData["connect_with_manager"]}
                    />
                  )}
                  {canConnectWithManager === false &&
                    checkData?.fields?.manager_reason && (
                      <EMPText
                        name={`manager_reason_${checkData?.case_check_id}`}
                        id={`manager_reason_${checkData?.case_check_id}`}
                        fieldId={
                          checkData?.fields?.manager_reason?.ibridge_field_id
                        }
                        label={checkData?.fields?.manager_reason?.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData?.fields?.manager_reason?.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_reason?.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_reason"}
                        fieldValue={fieldInput.manager_reason}
                        hasError={errorData["manager_reason"]}
                      />
                    )}
                  {checkData?.fields?.reporting_manager_in_company && (
                    <EMPRadio
                      name={`reporting_manager_in_company_${checkData?.case_check_id}`}
                      id={`reporting_manager_in_company_${checkData?.case_check_id}`}
                      fieldId={
                        checkData?.fields?.reporting_manager_in_company
                          ?.ibridge_field_id
                      }
                      label={
                        checkData?.fields?.reporting_manager_in_company?.label
                      }
                      isRequired={
                        isSelfEmployed == true
                          ? 0
                          : checkData?.fields?.reporting_manager_in_company
                              ?.is_mandatory
                      }
                      errId={`err_${checkData?.case_check_id}_${checkData?.fields?.reporting_manager_in_company?.ibridge_field_id}`}
                      options={
                        checkData?.fields?.reporting_manager_in_company
                          ?.getFieldDisplay?.optionArray?.options
                      }
                      handleRadioChange={handleRadioChange}
                      checkDetailsIndex={index}
                      fieldName={"reporting_manager_in_company"}
                      fieldValue={fieldInput.reporting_manager_in_company}
                      hasError={errorData["reporting_manager_in_company"]}
                    />
                  )}
                </div>
              </div>
              {checkData?.fields?.manager_first_name1 && (
                <div className="international-worker border-top my-1">
                  <h1 className="tabsContentHead pt-3">
                    Reporting Manager 2
                  </h1>
                  {clientId == "312004" && checkData?.check_id == "58" && (
                    <div className="row">
                      <p>
                        Your Current Employer will be contacted post your
                        joining at Sophos
                      </p>
                    </div>
                  )}
                  <div className="row">
                    {checkData?.fields?.manager_first_name1 ? (
                      <EMPText
                        name={`manager_first_name1_${checkData?.case_check_id}`}
                        id={`manager_first_name1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData?.fields?.manager_first_name1
                            ?.ibridge_field_id
                        }
                        label={checkData?.fields?.manager_first_name1?.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData?.fields?.manager_first_name1
                                ?.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_first_name1?.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_first_name1"}
                        fieldValue={fieldInput.manager_first_name1}
                        hasError={errorData["manager_first_name1"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.manager_middle_name1 ? (
                      <EMPText
                        name={`manager_middle_name1_${checkData?.case_check_id}`}
                        id={`manager_middle_name1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData?.fields?.manager_middle_name1
                            ?.ibridge_field_id
                        }
                        label={checkData?.fields?.manager_middle_name1?.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData?.fields?.manager_middle_name1
                                ?.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_middle_name1?.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_middle_name1"}
                        fieldValue={fieldInput?.manager_middle_name1}
                        hasError={errorData["manager_middle_name1"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.manager_last_name1 ? (
                      <EMPText
                        name={`manager_last_name1_${checkData?.case_check_id}`}
                        id={`manager_last_name1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData?.fields?.manager_last_name1
                            ?.ibridge_field_id
                        }
                        label={checkData?.fields?.manager_last_name1?.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData?.fields?.manager_last_name1
                                ?.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_last_name1?.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_last_name1"}
                        fieldValue={fieldInput?.manager_last_name1}
                        hasError={errorData["manager_last_name1"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.manager_email_id1 ? (
                      <EMPText
                        name={`manager_email_id1_${checkData?.case_check_id}`}
                        id={`manager_email_id1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.manager_email_id1.ibridge_field_id
                        }
                        label={checkData.fields.manager_email_id1.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.manager_email_id1.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.manager_email_id1.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_email_id1"}
                        fieldValue={fieldInput.manager_email_id1}
                        hasError={errorData["manager_email_id1"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.manager_mobile_no1 ? (
                      <EMPText
                        name={`manager_mobile_no1_${checkData?.case_check_id}`}
                        id={`manager_mobile_no1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.manager_mobile_no1.ibridge_field_id
                        }
                        label={checkData.fields.manager_mobile_no1.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.manager_mobile_no1.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.manager_mobile_no1.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_mobile_no1"}
                        fieldValue={fieldInput.manager_mobile_no1}
                        countryCodeValue={
                          mobileCode?.mobile_code_manager1 ||
                          checkData.fields.manager_mobile_no1.country_code_value
                        }
                        hasError={errorData["manager_mobile_no1"]}
                        countryCodeOptions={countryCodeOptions}
                        handleCountryCode={(e) =>
                          handleCountryCode(e, "mobile_code_manager1")
                        }
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.manager_designation1 ? (
                      <EMPText
                        name={`manager_designation1_${checkData?.case_check_id}`}
                        id={`manager_designation1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData?.fields?.manager_designation1
                            ?.ibridge_field_id
                        }
                        label={checkData?.fields?.manager_designation1?.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData?.fields?.manager_designation1
                                ?.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_designation1?.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"manager_designation1"}
                        fieldValue={fieldInput?.manager_designation1}
                        hasError={errorData["manager_designation1"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.connect_with_manager1 ? (
                      <EMPRadio
                        name={`connect_with_manager1_${checkData?.case_check_id}`}
                        id={`connect_with_manager1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData?.fields?.connect_with_manager1
                            ?.ibridge_field_id
                        }
                        label={checkData?.fields?.connect_with_manager1?.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData?.fields?.connect_with_manager1
                                ?.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData?.fields?.connect_with_manager1?.ibridge_field_id}`}
                        options={
                          checkData?.fields?.connect_with_manager1
                            ?.getFieldDisplay?.optionArray?.options
                        }
                        handleRadioChange={(radioValues) => {
                          const caseCheckId = checkData?.case_check_id;
                          handleRadioChange(radioValues);
                          if (radioValues?.value == "Yes") {
                            setCanConnectWithManager1((prevState) => ({
                              ...prevState,
                              [caseCheckId]: true,
                            }));
                          } else {
                            setCanConnectWithManager1((prevState) => ({
                              ...prevState,
                              [caseCheckId]: false,
                            }));
                          }
                        }}
                        checkDetailsIndex={index}
                        fieldName={"connect_with_manager1"}
                        fieldValue={fieldInput.connect_with_manager1}
                        hasError={errorData["connect_with_manager1"]}
                      />
                    ) : (
                      <></>
                    )}
                    {canConnectWithManager1 === false &&
                      (checkData.fields.manager_reason1 ? (
                        <EMPText
                          name={`manager_reason1_${checkData?.case_check_id}`}
                          id={`manager_reason1_${checkData?.case_check_id}`}
                          fieldId={
                            checkData?.fields?.manager_reason1?.ibridge_field_id
                          }
                          label={checkData?.fields?.manager_reason1?.label}
                          isRequired={
                            isSelfEmployed == true
                              ? 0
                              : checkData?.fields?.manager_reason1?.is_mandatory
                          }
                          errId={`err_${checkData?.case_check_id}_${checkData?.fields?.manager_reason1?.ibridge_field_id}`}
                          handleTextChange={handleTextChange}
                          checkDetailsIndex={index}
                          fieldName={"manager_reason1"}
                          fieldValue={fieldInput.manager_reason1}
                          // divClass="col-sm-8 col-md-12 col-xl-8"
                          hasError={errorData["manager_reason1"]}
                        />
                      ) : (
                        <></>
                      ))}
                    {checkData?.fields?.reporting_manager_in_company1 ? (
                      <EMPRadio
                        name={`reporting_manager_in_company1_${checkData?.case_check_id}`}
                        id={`reporting_manager_in_company1_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.reporting_manager_in_company1
                            .ibridge_field_id
                        }
                        label={
                          checkData.fields.reporting_manager_in_company1.label
                        }
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.reporting_manager_in_company1
                                .is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.reporting_manager_in_company1.ibridge_field_id}`}
                        options={
                          checkData.fields.reporting_manager_in_company1
                            .getFieldDisplay.optionArray.options
                        }
                        handleRadioChange={handleRadioChange}
                        checkDetailsIndex={index}
                        fieldName={"reporting_manager_in_company1"}
                        fieldValue={fieldInput.reporting_manager_in_company1}
                        hasError={errorData["reporting_manager_in_company1"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
              {checkData?.fields?.hr_first_name && (
                <div className="international-worker border-top my-1">
                  <h1 className="tabsContentHead pt-3">HR Details</h1>
                  {clientId == "131479" && (
                    <div className="row">
                      <p>
                        (Please provide only the Active contact details as this
                        information will be used for verification)
                      </p>
                    </div>
                  )}
                  {clientId == "312004" && checkData?.check_id == "58" && (
                    <div className="row">
                      <p>
                        Your Current Employer will be contacted post your
                        joining at Sophos
                      </p>
                    </div>
                  )}
                  <div className="row">
                    {checkData?.fields?.hr_first_name ? (
                      <EMPText
                        name={`hr_first_name_${checkData?.case_check_id}`}
                        id={`hr_first_name_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.hr_first_name.ibridge_field_id
                        }
                        label={checkData.fields.hr_first_name.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_first_name.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_first_name.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_first_name"}
                        fieldValue={fieldInput.hr_first_name}
                        hasError={errorData["hr_first_name"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.hr_middle_name ? (
                      <EMPText
                        name={`hr_middle_name_${checkData?.case_check_id}`}
                        id={`hr_middle_name_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.hr_middle_name.ibridge_field_id
                        }
                        label={checkData.fields.hr_middle_name.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_middle_name.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_middle_name.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_middle_name"}
                        fieldValue={fieldInput.hr_middle_name}
                        hasError={errorData["hr_middle_name"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.hr_last_name ? (
                      <EMPText
                        name={`hr_last_name_${checkData?.case_check_id}`}
                        id={`hr_last_name_${checkData?.case_check_id}`}
                        fieldId={checkData.fields.hr_last_name.ibridge_field_id}
                        label={checkData.fields.hr_last_name.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_last_name.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_last_name.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_last_name"}
                        fieldValue={fieldInput.hr_last_name}
                        hasError={errorData["hr_last_name"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.hr_email_id ? (
                      <EMPText
                        name={`hr_email_id_${checkData?.case_check_id}`}
                        id={`hr_email_id_${checkData?.case_check_id}`}
                        fieldId={checkData.fields.hr_email_id.ibridge_field_id}
                        label={checkData.fields.hr_email_id.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_email_id.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_email_id.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_email_id"}
                        fieldValue={fieldInput.hr_email_id}
                        hasError={errorData["hr_email_id"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData.fields.hr_mobile_no ? (
                      <EMPText
                        name={`hr_mobile_no_${checkData?.case_check_id}`}
                        id={`hr_mobile_no_${checkData?.case_check_id}`}
                        fieldId={checkData.fields.hr_mobile_no.ibridge_field_id}
                        label={checkData.fields.hr_mobile_no.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_mobile_no.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_mobile_no.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_mobile_no"}
                        fieldValue={fieldInput.hr_mobile_no}
                        countryCodeValue={
                          mobileCode?.mobile_code_hr ||
                          checkData.fields.hr_mobile_no.country_code_value
                        }
                        hasError={errorData["hr_mobile_no"]}
                        countryCodeOptions={countryCodeOptions}
                        handleCountryCode={(e) =>
                          handleCountryCode(e, "mobile_code_hr")
                        }
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.hr_designation ? (
                      <EMPText
                        name={`hr_designation_${checkData?.case_check_id}`}
                        id={`hr_designation_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.hr_designation.ibridge_field_id
                        }
                        label={checkData.fields.hr_designation.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_designation.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_designation.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_designation"}
                        fieldValue={fieldInput.hr_designation}
                        hasError={errorData["hr_designation"]}
                      />
                    ) : (
                      <></>
                    )}
                    {checkData?.fields?.hr_company_name ? (
                      <EMPText
                        name={`hr_company_name_${checkData?.case_check_id}`}
                        id={`hr_company_name_${checkData?.case_check_id}`}
                        fieldId={
                          checkData.fields.hr_company_name.ibridge_field_id
                        }
                        label={checkData.fields.hr_company_name.label}
                        isRequired={
                          isSelfEmployed == true
                            ? 0
                            : checkData.fields.hr_company_name.is_mandatory
                        }
                        errId={`err_${checkData?.case_check_id}_${checkData.fields.hr_company_name.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={index}
                        fieldName={"hr_company_name"}
                        fieldValue={fieldInput.hr_company_name}
                        hasError={errorData["hr_company_name"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        {!!(checkData?.document_visibility == 1 || MRLDocs?.required_documents?.length) && (
          <>
            <h6 className="fnt-smi-bld mb-0">Upload Files</h6>
            {/* <small>JPG, PDF, PNG, JPEG formats are supported</small> */}
          </>
        )}
        {!!(
          MRLDocs?.required_documents?.length) ?
          Object.entries(MRLDocs?.required_documents || {}).map(([key, value]) => {
            const totalCount =
              uploadedFilesCount && uploadedFilesCount[value.id]
                ? uploadedFilesCount[value.id]
                : 0;
            return (
              <>
                <EMPMultipleUpload
                  name={value.id}
                  id={`${checkData?.case_check_id}-${value.id}`}
                  title={value.document_name}
                  record={{
                    caseCheckId: checkData?.case_check_id,
                    docId: value.id,
                  }}
                  totalCount={totalCount}
                  getCount={getCountHandler}
                  getUpdatedEmploymentData={getUpdatedDocuments}
                  isMandatory={!!(value.is_mandatory == 1)}
                  isDownload={value?.is_download}
                />

                {errorData[`${value?.document_name}`] &&
                  totalCount == 0 &&
                  value.is_mandatory == 1 && (
                    <p className="err text-danger">This is a required field.</p>
                  )}
              </>
            );
          }) : !!(checkData?.document_visibility == 1 &&
          requiredDocuments) &&           
          Object.entries(requiredDocuments || {}).map(([key, value]) => {
            const totalCount =
              uploadedFilesCount && uploadedFilesCount[value.id]
                ? uploadedFilesCount[value.id]
                : 0;
            return (
              <>
                <EMPMultipleUpload
                  name={value.id}
                  id={`${checkData?.case_check_id}-${value.id}`}
                  title={value.document_name}
                  record={{
                    caseCheckId: checkData?.case_check_id,
                    docId: value.id,
                  }}
                  totalCount={totalCount}
                  getCount={getCountHandler}
                  getUpdatedEmploymentData={getUpdatedDocuments}
                  isMandatory={!!(value.is_mandatory == 1)}
                />

                {errorData[`${value?.document_name}`] &&
                  totalCount == 0 &&
                  value.is_mandatory == 1 && (
                    <p className="err text-danger">This is a required field.</p>
                  )}
              </>
            );
          })
        }
        {clientId == "219325" && checkData?.case_check_id == "58" && (
          <div className="row">
            <p>
              Please upload an email or any proof of leaving if you do not have
              not received the relieving letter yet
            </p>
          </div>
        )}
        {clientId == "275022" && (
          <div className="row">
            <p>
              Please share the documents with the concerned HR Representative.
            </p>
          </div>
        )}
        {
        // checkData?.document_visibility == 1 &&
          !documentCheckboxDisabledClients.includes(clientId) &&
          // value.upload_docs_later_checkbox &&
          checkData.upload_docs_later_checkbox == 1 && (
            <div className="row mt-3">
              {checkData.fields.is_document_provided ? (
                <EMPCheckbox
                  name={`is_document_provided_${checkData?.case_check_id}`}
                  id={`is_document_provided_${checkData?.case_check_id}`}
                  fieldId={
                    checkData.fields.is_document_provided.ibridge_field_id
                  }
                  label={checkData.fields.is_document_provided.label}
                  isRequired={
                    checkData.fields.is_document_provided.is_mandatory
                  }
                  errId={`err_${checkData?.case_check_id}_${checkData.fields.is_document_provided.ibridge_field_id}`}
                  handleCheckboxChange={handleCheckboxChange}
                  checkDetailsIndex={index}
                  fieldName={"is_document_provided"}
                  fieldValue={fieldInput.is_document_provided}
                  hasError={errorData["is_document_provided"]}
                />
              ) : (
                <></>
              )}
            </div>
          )}
        <div className="row mt-3">
          <div className="col-auto d-flex justify-content-between">
            <button
              className="btn btn-primary btn-lg btn-block mt-3"
              onClick={(e) => saveHandler(e, checkData?.case_check_id)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmploymentForm;